import { Injectable } from '@angular/core';
import { NavigationExtras, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { eMySalesPageTabString } from '../modules/my-sales/classes/eMySalesPageTab';
import { eMyPurchasesPageTabString } from '../modules/my-purchases/classes/eMyPurchasesPageTab';

@Injectable({
	providedIn: 'root'
})
export class RouterService {

	constructor(private router:Router,
				private location:Location) {
	}

	//#region Generic
	getState(key:string) : any | undefined {
		let state = window.history.state;
		if (state)
			return state[key];
		else
			return undefined;
	}
	get currentRoute() {
		return this.router.url;
	}
	updateQueryParameters(params:Params) {
		this.router.navigate([], {
			relativeTo: null,
			queryParams: params,
		});
	}
	reload() {
		location.reload();
	}
	toUrl(url:string, params?:Params) {     // Para links externos
		this.router.navigateByUrl(url, params);
	}
	goBack() {
		let state: { navigationId: number } = <{ navigationId: number }>this.location.getState();
		if (state.navigationId === 1) {
			this.toHome();
		} else {
			this.location.back();
		}
	}
	scrollUp() {
		window.scrollTo({top: 0});
	}
	addQueryParametersToCurrentRoute(params:Params, currentParams?:Params) {
		const newParams = { ...currentParams, ...params };
		this.router.navigate([], {
			queryParams: newParams,
			queryParamsHandling: "merge"
		});
	}
	removeQueryParameterFromCurrentRoute(key:string) {
		this.router.navigate([], {
			queryParams: {[key]: null},
			queryParamsHandling: "merge"
		});
	}
	removeAllQueryParametersFromCurrentRoute() {
		this.router.navigate([], {
			queryParams: {},
			queryParamsHandling: ""
		});
	}
	//#endregion

	//#region Auth and home
	readonly HOME = "/";
	readonly LOGIN = "/auth/ingresar";
	readonly SIGNUP = "/auth/registro";
	readonly UPDATE_PASSWORD = "/auth/cambiar-password";
	readonly FORGOT_PASSWORD = "/auth/olvide-mi-password";
	
	toLogin(afterLoginRedirectTo?:string) {
		this.router.navigateByUrl(this.LOGIN, {
			state: {"redirectAfter": afterLoginRedirectTo }
		});
	}
	toSignUp() {
		this.router.navigateByUrl(this.SIGNUP);
	}
	toHome() {
		this.router.navigateByUrl(this.HOME);
	}
	toUpdatePassword() {
		this.router.navigateByUrl(this.UPDATE_PASSWORD);
	}
	//#endregion

	//#region Estáticas
	readonly NOT_FOUND = "/pagina_no_encontrada";
	readonly IN_MAINTENANCE = "/mantenimiento";
	readonly INTERNAL_ERROR = "/error";

	to404() {
		this.router.navigateByUrl(this.NOT_FOUND);
	}
	toMaintenance() {
		this.router.navigateByUrl(this.IN_MAINTENANCE);
	}
	toInternalError() {
		this.router.navigateByUrl(this.INTERNAL_ERROR);
	}
	//#endregion

	//#region Search
	readonly SEARCH = "/buscar";
	
	toSearch(searchInput?:string, category_id?:number, discounts?:boolean, companyValue_id?:number) {
		this.router.navigate([this.SEARCH], { queryParams: { i:searchInput, c:category_id, d:discounts, v:companyValue_id }});
	}
	//#endregion

	//#region Company
	readonly OUR_VALUES = "/nuestros-pilares";
    readonly FAQ = "/preguntas-frecuentes";
	readonly ABOUT_US = "/quienes-somos";
	readonly PRIVACY_POLICY = "/politicas-de-privacidad";

	toOurValues() {
		this.router.navigateByUrl(this.OUR_VALUES);
	}
	//#endregion

	//#region Perfil
	readonly PROFILE = "/mi-perfil";
	
	toMyProfile() {
		this.router.navigateByUrl(this.PROFILE);
	}
	//#endregion

	//#region Comprar
	readonly PRODUCT = "/comprar";

	toProduct(id:number, onNewTab?:boolean) {
		if (onNewTab)
			window.open(this.PRODUCT +"/"+ id);
		else
			this.router.navigateByUrl(this.PRODUCT + "/" + id).then(this.scrollUp);
	}
	//#endregion

	//#region Vender
	readonly PRODUCT_FORM = "/vender";

	toCreateProduct() {
		this.router.navigateByUrl(this.PRODUCT_FORM);
	}
	toEditProduct(product_id:number, onNewTab?:boolean) {
		if (onNewTab)
			window.open(this.PRODUCT_FORM +"/"+ product_id);
		else
			this.router.navigateByUrl(this.PRODUCT_FORM +"/"+ product_id);
	}
	//#endregion

	//#region Mis compras
	readonly MY_PURCHASES = "/mis-compras";

	toMyPurchases(tab:eMyPurchasesPageTabString) {
		this.router.navigate([this.MY_PURCHASES], {
			queryParams: {
				tab: tab
			}
		});
	}
	toPurchase(purchase_id:number) {
		this.router.navigateByUrl(this.MY_PURCHASES + "/" + purchase_id);
	}
	//#endregion

	//#region Mis ventas
	readonly MY_SALES = "/mis-ventas";
	toMySales(tab:eMySalesPageTabString) {
		this.router.navigate([this.MY_SALES], {
			queryParams: {
				tab: tab
			},
		});
	}
	//#endregion

	//#region Carrito
	readonly CARTS = "/carrito";

	toCartsList() {
		this.router.navigateByUrl(this.CARTS);
	}
	toSingleCart(store_id:number) {
		this.router.navigateByUrl(this.CARTS +"/"+ store_id);
	}
	//#endregion

	//#region Ecotrends
	readonly ECOTRENDS = "/ecotrends";

	toEcotrends(slug?:string) {
		if (slug)
			this.router.navigateByUrl(this.ECOTRENDS +"/"+ slug);
		else
			this.router.navigateByUrl(this.ECOTRENDS);
	}
	//#endregion

	//#region Store
	readonly STORE = "/tienda";
	//#endregion

	//#region Notificaciones
	readonly NOTIFICATIONS = "/notificaciones"
	//#endregion

	//#region Términos y condiciones
	readonly TERMS_AND_CONDITIONS = "/terminos";
	//#endregion

	//#region Ayuda
	private readonly HELP = "/ayuda";
	readonly HELP_PURCHASE = this.HELP + "/comprar";
	readonly HELP_SALE = this.HELP + "/vender";
	//#endregion
}